export default __webpack_public_path__ + "static/media/illustration.a9679bd6.svg";